import React from 'react';
import PropTypes from 'prop-types';
import MainHeader from './MainHeader/MainHeader';
import Sidebar from '../Sidebar/Sidebar';
import './Header.css';
import SidebarOption from '../Sidebar/SidebarOption/SidebarOption';
import Navigator from '../../../utils/Navigator';
import Translate from '../../../utils/Translate';
import * as Pages from '../../../utils/Pages';
import UpaTracker from '../../../tracking/UpaTracker';
import Environment from '../../../utils/Environment';
import SubTitleHeader from './SubTitleHeader/SubTitleHeader';

const isUserLogged = Environment.isUserLogged;
const Header = ({
  hide,
  name,
  page,
  subtitle
}) => (
  !hide && (
  <div className="dashboard-aftersale-header eva-3-row -no-gutter -eva-3-valign Header">
    <div className="col -sm-12">
      {isUserLogged &&<div className="dashboard-aftersale-subheader-container -sidebar">
        <div className="dashboard-aftersale-usernav-container eva-3-container">
          <MainHeader name={name}/>
          {subtitle && (<SubTitleHeader name={subtitle}/>)}
        </div>
         <div className="col -sm-4 dashboard-aftersale-sidebar-container dashboard-aftersale-sidebar -eva-3-halign -eva-3-pl-xlg">
          <Sidebar>
            <div>
              <SidebarOption
                linkTo={Navigator.personalInfoPage}
                icon="user"
                title={Translate.message('upsert-personal-info.title')}
                disabled={page === Pages.PERSONAL_INFO}
              />
              <SidebarOption
                linkTo={Navigator.paymentMethodsPage}
                icon="card"
                title={Translate.message('Medios de pago')}
                disabled={page === Pages.PAYMENT_METHODS}
              />
              <SidebarOption
                linkTo={Navigator.communicationSettingsPage}
                icon="notification"
                title={Translate.message('Facebook Messenger y WhatsApp')}
                disabled={page === Pages.PROFILE}
              />
              <SidebarOption
                linkTo={Navigator.travelCompanionsPage}
                icon="family"
                title={Translate.message('Acompañantes de viaje')}
                disabled={page === Pages.TRAVEL_COMPANION}
              />
              {!Environment.isWhiteLabel &&
              <SidebarOption
                linkTo={Navigator.surveyPage}
                icon="chat"
                title={Translate.message('Opiniones')}
                onClick={() => UpaTracker.track('surveys')}
                force
              />
                  }
              <SidebarOption
                linkTo={Navigator.activeSessionsPage}
                icon="cell-phone"
                title={Translate.message('Sesiones activas')}
                disabled={page === Pages.ACTIVE_SESSIONS}
              />
              <SidebarOption
                linkTo={Navigator.deleteAccountPage}
                icon="trash"
                title={Translate.message('Eliminar cuenta')}
                disabled={page === Pages.DELETE_ACCOUNT}
              />
            </div>
          </Sidebar>
        </div>
      </div>}
    </div>
  </div>
  )
);

Header.defaultProps = {
  name: undefined,
  _subtitle: '',
  hide: false,
  page: undefined,
};

Header.propTypes = {
  name: PropTypes.string,
  subtitle: PropTypes.string,
  hide: PropTypes.bool,
  page: PropTypes.string.isRequired,
};

export default Header;
